import { render, staticRenderFns } from "./InvoiceLoader.vue?vue&type=template&id=5fb1bba8&scoped=true"
import script from "./InvoiceLoader.vue?vue&type=script&lang=js"
export * from "./InvoiceLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb1bba8",
  null
  
)

export default component.exports